var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 94,
    viewBox: "0 0 93 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_27120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 51.3594V84.7812C2.90625 87.9912 5.5088 90.5938 8.71875 90.5938C11.9287 90.5938 14.5312 87.9912 14.5312 84.7812V48.4531H5.8125C4.20825 48.4531 2.90625 49.7551 2.90625 51.3594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1875 3.40625H20.3437C18.7395 3.40625 17.4375 4.70825 17.4375 6.3125V84.7812C17.4375 87.0176 16.5889 89.0505 15.204 90.5938H84.2812C87.4912 90.5938 90.0937 87.9912 90.0937 84.7812V6.3125C90.0937 4.70825 88.7917 3.40625 87.1875 3.40625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1875 0.5H20.3438C17.1309 0.5 14.5312 3.09964 14.5312 6.3125V45.5469H5.8125C2.59964 45.5469 0 48.1465 0 51.3594V84.7812C0 89.5955 3.90455 93.5 8.71875 93.5H84.2812C89.0955 93.5 93 89.5955 93 84.7812V6.3125C93 3.09964 90.4004 0.5 87.1875 0.5ZM14.5312 84.7812C14.5312 87.9912 11.9287 90.5938 8.71875 90.5938C5.5088 90.5938 2.90625 87.9912 2.90625 84.7812V51.3594C2.90625 49.7551 4.20825 48.4531 5.8125 48.4531H14.5312V84.7812ZM90.0938 84.7812C90.0938 87.9912 87.4912 90.5938 84.2812 90.5938H15.204C16.5889 89.0505 17.4375 87.0176 17.4375 84.7812V6.3125C17.4375 4.70825 18.7395 3.40625 20.3438 3.40625H87.1875C88.7917 3.40625 90.0938 4.70825 90.0938 6.3125V84.7812Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0156 36.8281H30.5156C29.712 36.8281 29.0625 37.4777 29.0625 38.2812C29.0625 39.0848 29.712 39.7344 30.5156 39.7344H77.0156C77.8192 39.7344 78.4688 39.0848 78.4688 38.2812C78.4688 37.4777 77.8192 36.8281 77.0156 36.8281Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0156 28.1094H30.5156C29.712 28.1094 29.0625 28.7589 29.0625 29.5625C29.0625 30.3661 29.712 31.0156 30.5156 31.0156H77.0156C77.8192 31.0156 78.4688 30.3661 78.4688 29.5625C78.4688 28.7589 77.8192 28.1094 77.0156 28.1094Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0156 54.2656H30.5156C29.712 54.2656 29.0625 54.9152 29.0625 55.7188C29.0625 56.5223 29.712 57.1719 30.5156 57.1719H77.0156C77.8192 57.1719 78.4688 56.5223 78.4688 55.7188C78.4688 54.9152 77.8192 54.2656 77.0156 54.2656Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0156 62.9844H30.5156C29.712 62.9844 29.0625 63.6339 29.0625 64.4375C29.0625 65.2411 29.712 65.8906 30.5156 65.8906H77.0156C77.8192 65.8906 78.4688 65.2411 78.4688 64.4375C78.4688 63.6339 77.8192 62.9844 77.0156 62.9844Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0156 71.7031H30.5156C29.712 71.7031 29.0625 72.3527 29.0625 73.1562C29.0625 73.9598 29.712 74.6094 30.5156 74.6094H77.0156C77.8192 74.6094 78.4688 73.9598 78.4688 73.1562C78.4688 72.3527 77.8192 71.7031 77.0156 71.7031Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0156 45.5469H30.5156C29.712 45.5469 29.0625 46.1964 29.0625 47C29.0625 47.8036 29.712 48.4531 30.5156 48.4531H77.0156C77.8192 48.4531 78.4688 47.8036 78.4688 47C78.4688 46.1964 77.8192 45.5469 77.0156 45.5469Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5156 22.2969H52.3125C53.1161 22.2969 53.7656 21.6473 53.7656 20.8438C53.7656 20.0402 53.1161 19.3906 52.3125 19.3906H30.5156C29.712 19.3906 29.0625 20.0402 29.0625 20.8438C29.0625 21.6473 29.712 22.2969 30.5156 22.2969Z",
    fill: "#354853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 51.3594V84.7812C2.90625 87.9912 5.5088 90.5938 8.71875 90.5938C11.9287 90.5938 14.5312 87.9912 14.5312 84.7812V48.4531H5.8125C4.20825 48.4531 2.90625 49.7551 2.90625 51.3594Z",
    fill: "#2A9D8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_27120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.6337fa756668f59ce8439e0a86c90ab9.svg";
export { ForwardRef as ReactComponent };